module.exports = __webpack_public_path__ + "static/media/tr-TR.70f8c2d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/tr-TR.png
// module id = 957
// module chunks = 0